import { ACTION_TYPES, STATUS_TYPES, Story } from '@shared/api/types/story';

export const magicstoreStormTrade: Story = {
  id: 'magicstore-storm-trade',
  type: 'SOQUEST',
  status: STATUS_TYPES.ACTIVE,
  name: 'Magic Store storm trade',
  index: 0,
  content: {
    type: ACTION_TYPES.SOQUEST,
    metadata: {
      title: 'Magic Store Campaign: Earn 0.1 USDT in the Storm Trade Campaign',
      description:
        'Join the web3 world at Magic Store by Magic Square. Earn 0.1 USDT by completing the Campaign',
      keywords:
        'Web3, Crypto, Hot Offer, Magic Store, Magic Square, Storm Trade Campaign, SHIB, Web3 App Store, Decentralized Apps, Crypto Rewards, Storm Trade, DApps, Win Crypto, Digital Assets, Web3 Technology',
    },
    config: {
      key: '4f0251557530b00cf175a032a91606206d25',
      scode: 'MagicSquare',
      ccode: 'AGBemkkxlE',
    },
  },
};
